import { SET_MAIN_PAGE_CONTENT, SET_POSTS_CONTENT, ADD_POST_FIELD, DELETE_POST_FIELD, CLEAN_FIELDS } from 'constants/templateGenerator';

const setMainPageContent = (data) => {
    return {
        type: SET_MAIN_PAGE_CONTENT,
        payload: data
    };
};

const setPostsContent = (key, data) => {
    return {
        type: SET_POSTS_CONTENT,
        postIndex: key,
        payload: data
    };
};

const addPostField = () => {
    return {
        type: ADD_POST_FIELD
    };
};

const deletePostField = () => {
    return {
        type: DELETE_POST_FIELD
    };
};

const cleanFields = () => {
    return {
        type: CLEAN_FIELDS
    };
};

export { setMainPageContent, setPostsContent, addPostField, deletePostField, cleanFields };